export default function Pandas_Editor() {
  return <div>Pandas_Editor </div>;
}
